// ============================================
// 📋 FORMULÁRIO MULTI-IDS - form-multi-ids.js
// Suporta múltiplos formulários com IDs diferentes
// Form ID: 899185
// ============================================

(function initMultiForm() {
  console.log("🔵 [FORM MULTI] Inicializando sistema multi-formulários");
  
  const COOKIE_NAME = "utm_campaign";
  const COOKIE_DAYS = 30;
  const FORM_ID = "899185";
  
  // ==========================================
  // 🎯 ADICIONE TODOS OS IDs DE CONTAINERS AQUI
  // ==========================================
  const CONTAINER_IDS = [
    "#AMkIvZ2cyb1Fsdm1jY__forms_inline_w3ay6L", // formulario assinatura
    "#AVjRMNEdKYWFnSWdhR__forms_inline_iqhdNF",
    "#ANE43QWx3TTRTbmJVb__forms_inline_ARtfP8"
  ];

  // Controle de instâncias processadas
  const processedForms = new WeakSet();

  // ==========================================
  // 🔧 FUNÇÕES AUXILIARES - UTM
  // ==========================================
  function setCookie(name, value, days) {
    if (!value) return;
    const expires = new Date();
    expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
    document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires.toUTCString()}; path=/`;
    console.log("🔵 [FORM MULTI] Cookie UTM salvo:", value);
  }

  function getCookie(name) {
    const cookies = document.cookie.split("; ");
    const cookie = cookies.find(c => c.startsWith(name + "="));
    return cookie ? decodeURIComponent(cookie.split("=")[1]) : "";
  }

  function getUTMValue() {
    const params = new URLSearchParams(window.location.search);
    const utmFromUrl = params.get("utm_campaign");
    
    let utmValue = "";
    if (utmFromUrl) {
      utmValue = utmFromUrl;
      setCookie(COOKIE_NAME, utmFromUrl, COOKIE_DAYS);
    } else {
      utmValue = getCookie(COOKIE_NAME);
    }
    
    return utmValue;
  }

  // ==========================================
// 🎭 MÁSCARAS DE INPUT
// ==========================================
function applyInputMasks(targetForm) {
  // EMAIL - validação com @
  const emailInput = targetForm.querySelector('#email');
  if (emailInput) {
    emailInput.addEventListener('blur', () => {
  const val = emailInput.value;
  const isValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val); // ✅ verifica formato real
  if (val && !isValid) {
    emailInput.style.borderColor = '#ff4d4d';
    emailInput.title = 'Digite um e-mail válido (ex: nome@dominio.com)';
  } else {
    emailInput.style.borderColor = '';
    emailInput.title = '';
  }
});

emailInput.addEventListener('input', () => {
  const isValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailInput.value);
  if (isValid) emailInput.style.borderColor = '';
});
  }

  // TELEFONE - máscara +55 (XX) XXXXX-XXXX
  const phoneInput = targetForm.querySelector('#phone_number');
  if (phoneInput) {
    phoneInput.setAttribute('maxlength', '19');
    phoneInput.setAttribute('placeholder', '+55 (XX) XXXXX-XXXX');

    phoneInput.addEventListener('input', (e) => {
      let val = e.target.value.replace(/\D/g, ''); // remove não-dígitos

      // Limita a 13 dígitos (55 + DDD 2 + número 9)
      if (val.length > 13) val = val.slice(0, 13);

      // Aplica máscara progressiva
      if (val.length <= 2) {
        val = val.length ? '+' + val : '';
      } else if (val.length <= 4) {
        val = `+${val.slice(0, 2)} (${val.slice(2)}`;
      } else if (val.length <= 9) {
        val = `+${val.slice(0, 2)} (${val.slice(2, 4)}) ${val.slice(4)}`;
      } else {
        val = `+${val.slice(0, 2)} (${val.slice(2, 4)}) ${val.slice(4, 9)}-${val.slice(9)}`;
      }

      e.target.value = val;
    });

    // Impede colar conteúdo inválido
    phoneInput.addEventListener('paste', (e) => {
  e.preventDefault();
  const pasted = (e.clipboardData || window.clipboardData).getData('text').replace(/\D/g, '');
  phoneInput.value = pasted; // ✅ injeta o texto antes de disparar
  phoneInput.dispatchEvent(new Event('input', { bubbles: true }));
});
  }
}

  // ==========================================
  // 🎨 APLICAR ESTILOS NO FORMULÁRIO
  // ==========================================
  function applyFormStyles(targetForm, appEmbed, utmField, containerId) {
    const isMobile = window.innerWidth <= 768;
    let formStarted = false;
    const utmValue = getUTMValue();

    console.log("✅ [FORM MULTI] Aplicando estilos no formulário");
    console.log("   📦 Container ID:", containerId);
    console.log("   📍 Página:", window.location.pathname);

    // ==========================================
    // 🏷️ UTM - CAMPO OCULTO
    // ==========================================
    if (utmValue && utmField) {
      utmField.value = utmValue;
      utmField.dispatchEvent(new Event("input", { bubbles: true }));
      utmField.dispatchEvent(new Event("change", { bubbles: true }));
      console.log("✅ [FORM MULTI] UTM aplicado:", utmValue);
    }

    // Oculta o campo UTM completamente
    if (utmField) {
      const utmWrapper = utmField.closest('[data-testid="form-field-wrapper"]');
      if (utmWrapper) {
        utmWrapper.style.cssText = "display: none !important; visibility: hidden !important; height: 0 !important; margin: 0 !important; padding: 0 !important;";
      }
      
      utmField.style.cssText = "display: none !important; visibility: hidden !important;";
      
      const utmLabel = appEmbed.shadowRoot.querySelector('label[for*="utm"]');
      if (utmLabel) {
        utmLabel.style.cssText = "display: none !important; visibility: hidden !important;";
      }
    }

    // ==========================================
    // 🎨 ESTILOS VIA ADOPTED STYLESHEETS
    // ==========================================
    const shadow = appEmbed.shadowRoot;

    if (shadow) {
      const sheet = new CSSStyleSheet();

      sheet.replaceSync(`
        /* FORM WRAPPER */
        .section-form {
          padding: ${isMobile ? '0px' : '0px'};
          max-width: 90% !important;
          margin: 0 auto;
        }

        h2._textHeading_2aowh_35{
            font-size: 39px;
            color: #fff;
            text-transform: uppercase;
            text-align: left;
            margin-bottom: 20px;
        }

        ._textBody_2aowh_10 p{
            font-size: 18px;
          text-align: left;
          line-height: 150%;
          color: #fff;
          font-weight: 400;
        }

        /* FORM - fundo transparente */
        form[data-testid="form"] {
              display: grid;
            grid-template-columns: 50% 48%;
        }

        /* INPUTS - estilo base */
        input[id="first_name"],
        input[id="email"],
        input[id="phone_number"] {
          background: #2f5859 !important;
          border: 1.5px solid #3d6b5e !important;
          border-radius: 14px !important;
          color: #ffffff !important;
          font-family: Montserrat, sans-serif !important;
          font-size: 15px !important;
          padding: 16px 18px !important;
          width: 100% !important;
          box-sizing: border-box !important;
          transition: border-color 0.3s, box-shadow 0.3s !important;
          outline: none !important;
        }

        /* INPUTS - placeholder */
        input[id="first_name"]::placeholder,
        input[id="email"]::placeholder,
        input[id="phone_number"]::placeholder {
          color: #2f5859;
          font-family: Montserrat, sans-serif !important;
        }

        /* INPUTS - focus */
        input[id="first_name"]:focus,
        input[id="email"]:focus,
        input[id="phone_number"]:focus {
          border-color: #2f5859;
          box-shadow: 0 0 0 3px rgba(95, 168, 138, 0.15) !important;
        }

        /* LABELS */
        label {
          color: #fff !important;
          font-family: Montserrat, sans-serif !important;
          font-size: 14px !important;
          font-weight: 500 !important;
        }

        /* BOTÃO */
        button[data-testid="btn-form-submit"] {
          background: #fff ;
          color: #022D2F !important;
          grid-column: 1;
          border-radius: 100px;
          font-family: 'Montserrat';
          font-weight: bold;
          font-size: 16px;
        }

        /* BOTÃO DE PAÍS */
        button[class*="selectToggle"] {
          background: #2a4a42 !important;
          border: 1.5px solid #3d6b5e !important;
          border-radius: 10px !important;
          height: 100% !important;
          max-height: 51px !important;
          display: flex !important;
          align-items: center !important;
          justify-content: center !important;
          margin-right: 5px !important;
        }

        /* TEXTAREA */

        ._formFieldContainer_1mxsl_5:has(#first_name){
            grid-column: 1 / span 2
        }

        ._formFieldContainer_1mxsl_5:focus-within ._formInputFieldLabel_1mxsl_38,
        ._formFieldContainer_1mxsl_5 ._inputFilled_1mxsl_74{
          top: 12px !important;
        }
        

            

        ._formPhoneInputContainer_piv1u_6{
            grid-template-columns: 100% !important;
        }
        ._formPhoneInputContainer_piv1u_6 .phone-country-selector{
            display: none;
        }

        ._formSubmitButton_cit2d_96{
            color: #fff !important;
        }

        textarea[name="custom#mensagem"] {
          background: transparent !important;
          border: 1px solid rgb(149, 149, 149) !important;
        }

        h2._formBannerHeading_z5ku3_9{
          font-size: 0 !important;
        }
        h2._formBannerHeading_z5ku3_9::before{
          content: "Falta pouco para o seu café chegar!";
          font-size: 22px;
          color: #fff;
          margin-bottom: 30px;
        }

        section._formBannerContainer_z5ku3_1 ._textBody_2aowh_10 p{
          font-size: 0;
        }

        section._formBannerContainer_z5ku3_1 ._textBody_2aowh_10 p::before{
          content: "Recebemos seu interesse em fazer parte do nosso Clube de Assinatura! Nossos especialistas em grãos entrarão em contato com você em breve para finalizar os detalhes da sua assinatura e garantir que você receba a melhor experiência sensorial em casa. Até logo!";
          font-size: 16px;
          color: #fff;
          text-align: center;
              line-height: normal;
          }



        @media screen and (min-width: 1280px) and (max-width: 1600px){
          h2._textHeading_2aowh_35{
            font-size: 32px;
          }

          .section-form{
            padding: 20px;
            max-width: 90% !important;
            margin: 0 auto;
          }
        }

        /* ── MOBILE ── */
        @media (max-width: 768px) {

          form[data-testid="form"] {
            grid-template-columns: 1fr !important;
          }

          ._formFieldContainer_1mxsl_5:has(#first_name) {
            grid-column: 1 !important;
          }

          button[data-testid="btn-form-submit"] {
            grid-column: 1 !important;
          }

          .section-form{
            background: #022D2F;
            max-width: 100% !important;
          }

          h2._textHeading_2aowh_35{
            font-size: 20px;
          }

          ._gridItem_1q1d2_172:nth-child(2){
            padding: 20px;
            background: #0A3A3C;
            border-bottom: 0;
            margin: 0;
          }
      `);

      shadow.adoptedStyleSheets = [
        ...shadow.adoptedStyleSheets,
        sheet
      ];

      const formWrapper = shadow.querySelector('section[data-sizing="form-wrapper"]');
      if (formWrapper) {
        formWrapper.classList.add('section-form');
      }
    }

    // 🎭 APLICAR MÁSCARAS
    applyInputMasks(targetForm);

       // ==========================================
// 🌐 TRADUÇÃO DE ERROS DE VALIDAÇÃO
// ==========================================
function translateFormErrors(shadow) {
  const translations = {
    // Erros de campo obrigatório
    'First name is required': 'Nome é obrigatório',
    'Last name is required': 'Sobrenome é obrigatório',
    'Phone number is required': 'Telefone é obrigatório',
    'Email is required': 'E-mail é obrigatório',
    'Email is invalid': 'E-mail é inválido',
    'Field is required': 'Campo obrigatório',
    'This field is required': 'Este campo é obrigatório',

    // Erros de formato
    'Please enter a valid email': 'Digite um e-mail válido',
    'Please enter a valid email address': 'Digite um e-mail válido',
    'Invalid email address': 'E-mail inválido',
    'Please enter a valid phone number': 'Digite um telefone válido',
    'Invalid phone number': 'Telefone inválido',

    // Outros
    'Please fill in this field': 'Preencha este campo',
    'Value is too short': 'Valor muito curto',
    'Value is too long': 'Valor muito longo',
  };

  function applyTranslations() {
    const errorElements = shadow.querySelectorAll(
      'output[role="alert"], ._formError_1mxsl_21, [class*="formError"]'
    );

    errorElements.forEach(el => {
      const original = el.textContent.trim();
      if (translations[original]) {
        el.textContent = translations[original];
      }
    });
  }

  // Aplica imediatamente
  applyTranslations();

  // Observa mudanças para traduzir erros que aparecem após submit
  const errorObserver = new MutationObserver(() => {
    applyTranslations();
  });

  errorObserver.observe(shadow, {
    childList: true,
    subtree: true,
    characterData: true
  });
}

    if (shadow) {
  translateFormErrors(shadow);
}

    // ==========================================
    // 📝 INPUTS - APENAS EVENTOS DE TRACKING
    // ==========================================
    const allInputs = targetForm.querySelectorAll('input');
    console.log(`🔵 [FORM MULTI] ${allInputs.length} inputs encontrados`);

    allInputs.forEach(input => {
      // Evento de início de preenchimento
      input.addEventListener('focus', () => {
        if (!formStarted) {
          formStarted = true;

          console.log("🎯 [FORM MULTI] ========================================");
          console.log("🎯 [FORM MULTI] USUÁRIO COMEÇOU A PREENCHER!");
          console.log("🎯 [FORM MULTI] Form ID: 899185");
          console.log("🎯 [FORM MULTI] Container:", containerId);
          console.log("🎯 [FORM MULTI] Página:", window.location.pathname);
          console.log("🎯 [FORM MULTI] ========================================");

          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            'event': 'initiate_form',
            'form_id': FORM_ID,
            'form_type': 'standard',
            'container_id': containerId,
            'page_url': window.location.href,
            'timestamp': new Date().getTime()
          });
        }
      }, { once: true });
    });

    // ==========================================
    // 🏷️ LABELS - translateY para phone_number
    // ==========================================
    const allLabels = targetForm.querySelectorAll('label');
    allLabels.forEach(label => {
      if (label.getAttribute('for') === 'label-phone_number') {
        console.log("passou");
        label.style.setProperty('transform', 'translateY(-10px)', 'important');
      }
    });

    // ==========================================
    // 🚀 BOTÃO DE ENVIO - APENAS EVENTO
    // ==========================================
    const submitBtn = targetForm.querySelector('button[data-testid="btn-form-submit"]');
    if (submitBtn) {
      submitBtn.addEventListener('mouseenter', () => {
        submitBtn.style.transform = "translateY(-2px)";
      });

      submitBtn.addEventListener('mouseleave', () => {
        submitBtn.style.transform = "translateY(0)";
      });

      submitBtn.addEventListener("click", () => {
        const nome      = targetForm.querySelector('#first_name')?.value || '';
        const email     = targetForm.querySelector('#email')?.value || '';
        const whatsapp  = targetForm.querySelector('#phone_number')?.value || '';

        console.log("🚀 [FORM MULTI] ========================================");
        console.log("🚀 [FORM MULTI] FORMULÁRIO ENVIADO!");
        console.log("🚀 [FORM MULTI] Form ID: 899185");
        console.log("🚀 [FORM MULTI] Container:", containerId);
        console.log("🚀 [FORM MULTI] Página:", window.location.pathname);
        console.log("🚀 [FORM MULTI] ========================================");
        console.log("🚀 [FORM MULTI] Dados capturados:");
        console.log("   📝 Nome:", nome);
        console.log("   📧 Email:", email);
        console.log("   📱 WhatsApp:", whatsapp);
        console.log("   🏷️ UTM:", utmValue);
        console.log("🚀 [FORM MULTI] ========================================");
      });
    }

    // Marca como processado usando WeakSet
    processedForms.add(targetForm);
    console.log("✅ [FORM MULTI] Formulário configurado com sucesso!");
  }

  // ==========================================
  // 🔍 PROCESSAR TODOS OS FORMULÁRIOS
  // ==========================================
  const processAllForms = () => {
    let formsFound = 0;
    let formsProcessed = 0;

    CONTAINER_IDS.forEach(containerId => {
      const container = document.querySelector(containerId);

      if (!container) {
        return;
      }

      const appEmbed = container.querySelector('#app-embed');
      
      if (!appEmbed || !appEmbed.shadowRoot) {
        return;
      }

      const targetForm = appEmbed.shadowRoot.querySelector('form');
      const utmField = appEmbed.shadowRoot.querySelector('#custom\\#utm');

      if (!targetForm) {
        return;
      }

      formsFound++;

      if (processedForms.has(targetForm)) {
        return;
      }

      applyFormStyles(targetForm, appEmbed, utmField, containerId);
      formsProcessed++;
    });

    if (formsProcessed > 0) {
      console.log(`✅ [FORM MULTI] ${formsProcessed} formulário(s) processado(s) nesta execução`);
    }

    return formsProcessed > 0;
  };

  // ==========================================
  // 👀 OBSERVER PERMANENTE - MONITORA DOM
  // ==========================================
  const observer = new MutationObserver(() => {
    processAllForms();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  // ==========================================
  // 🔄 LISTENER PARA MUDANÇAS DE PÁGINA
  // ==========================================
  let lastUrl = location.href;
  new MutationObserver(() => {
    const url = location.href;
    if (url !== lastUrl) {
      lastUrl = url;
      console.log("🔄 [FORM MULTI] Mudança de página detectada:", url);
      
      setTimeout(() => processAllForms(), 500);
      setTimeout(() => processAllForms(), 1000);
      setTimeout(() => processAllForms(), 2000);
    }
  }).observe(document, { subtree: true, childList: true });

  // Para navegação com History API
  const originalPushState = history.pushState;
  const originalReplaceState = history.replaceState;

  history.pushState = function() {
    originalPushState.apply(this, arguments);
    console.log("🔄 [FORM MULTI] PushState detectado");
    setTimeout(() => processAllForms(), 500);
    setTimeout(() => processAllForms(), 1000);
  };

  history.replaceState = function() {
    originalReplaceState.apply(this, arguments);
    console.log("🔄 [FORM MULTI] ReplaceState detectado");
    setTimeout(() => processAllForms(), 500);
  };

  window.addEventListener('popstate', () => {
    console.log("🔄 [FORM MULTI] Popstate detectado (navegação voltar/avançar)");
    setTimeout(() => processAllForms(), 500);
    setTimeout(() => processAllForms(), 1000);
  });

  // ==========================================
  // 📱 LISTENER PARA RESIZE (Mobile/Desktop)
  // ==========================================
  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      console.log("📱 [FORM MULTI] Resize detectado, reprocessando formulários");
      processAllForms();
    }, 250);
  });

  // ==========================================
  // 🚀 INICIALIZAÇÃO
  // ==========================================
  processAllForms();
  
  setTimeout(() => processAllForms(), 500);
  setTimeout(() => processAllForms(), 1000);
  setTimeout(() => processAllForms(), 2000);
  setTimeout(() => processAllForms(), 3000);

  console.log("✅ [FORM MULTI] Sistema multi-formulários ativado!");
  console.log("📦 [FORM MULTI] Monitorando", CONTAINER_IDS.length, "container(s):");
  CONTAINER_IDS.forEach((id, index) => {
    console.log(`   ${index + 1}. ${id}`);
  });
  console.log("📍 [FORM MULTI] Página inicial:", window.location.pathname);

  window.reprocessAllForms = () => {
    console.log("🔧 [FORM MULTI] Reprocessamento manual solicitado");
    processAllForms();
  };

  window.addFormContainer = (newContainerId) => {
    if (!CONTAINER_IDS.includes(newContainerId)) {
      CONTAINER_IDS.push(newContainerId);
      console.log("➕ [FORM MULTI] Novo container adicionado:", newContainerId);
      processAllForms();
    } else {
      console.log("⚠️ [FORM MULTI] Container já existe na lista:", newContainerId);
    }
  };

})();